import { useEffect, useState } from "react";

const ticker = [
  "刚刚发生 · 新剧大结局登顶热搜",
  "新瓜出炉 · 顶流演唱会官宣抢票通道",
  "最新猛料 · AI 眼镜新品发布现场排队",
  "当天热点 · 中秋档电影预售全面开启",
  "一手速递 · 国货美妆联名礼盒一秒售罄",
];

export default function Hero() {
  const [clock, setClock] = useState("");
  const [tickIdx, setTickIdx] = useState(0);

  useEffect(() => {
    const pad = (n: number) => String(n).padStart(2, "0");
    const update = () => {
      const d = new Date();
      setClock(`${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`);
    };
    update();
    const t = window.setInterval(update, 1000);
    const ticker = window.setInterval(() => setTickIdx((i) => (i + 1) % ticker.length), 3000);
    return () => {
      window.clearInterval(t);
      window.clearInterval(ticker);
    };
  }, []);

  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-16">
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(oklch(var(--primary-500)) 1px, transparent 1px), radial-gradient(oklch(var(--secondary-500)) 1px, transparent 1px)",
          backgroundSize: "28px 28px",
          backgroundPosition: "0 0, 14px 14px",
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-6xl px-4 pb-14 pt-10 md:px-6 md:pb-20 md:pt-16">
        <div className="grid items-center gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
              </span>
              实时更新 · 今天的新瓜都在这里
            </div>

            <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
              吃瓜最新
              <span className="mt-2 block bg-gradient-to-r from-primary-600 to-accent-600 bg-clip-text text-transparent">
                今日新瓜 · 当天热点一手速递
              </span>
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              刚刚发生的热点事件、新瓜出炉第一时间汇总。点开这里，就能掌握当天最热爆料与新鲜猛料，
              随时围观瓜田动态与网友热议焦点，不错过任何一条刚发生的劲爆消息。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#hot"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
              >
                <i className="ri-fire-line mr-2" aria-hidden="true" />
                查看今日热搜榜
              </a>
              <a
                href="#latest"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-background-100 px-6 py-3 text-sm font-semibold text-foreground-800 ring-1 ring-background-300 transition-colors hover:bg-background-200"
              >
                <i className="ri-timer-flash-line mr-2 text-primary-600" aria-hidden="true" />
                围观最新爆料
              </a>
            </div>

            <div className="mt-7 flex items-center gap-4 text-xs text-foreground-500">
              <div className="flex items-center gap-1.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-lg text-primary-600">
                  <i className="ri-flashlight-fill" aria-hidden="true" />
                </span>
                <div>
                  <p className="font-semibold text-foreground-900">今日刷新 100+</p>
                  <p>条热点资讯</p>
                </div>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-100 text-lg text-secondary-600">
                  <i className="ri-community-line" aria-hidden="true" />
                </span>
                <div>
                  <p className="font-semibold text-foreground-900">累计 380 万</p>
                  <p>瓜友围观讨论</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-100/60 shadow-card">
              <div className="flex items-center justify-between border-b border-background-200 bg-background-50/80 px-5 py-3">
                <p className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-900">
                  <i className="ri-live-line text-primary-600" aria-hidden="true" />
                  瓜田滚动直播
                </p>
                <span className="flex items-center gap-1.5 rounded-full bg-background-200/70 px-2.5 py-1 text-xs text-foreground-700">
                  <i className="ri-time-line" aria-hidden="true" />
                  <span className="tabular-nums">{clock}</span>
                </span>
              </div>
              <ul className="space-y-1 px-4 py-3">
                {ticker.map((t, i) => (
                  <li key={t}>
                    <a
                      href="#latest"
                      className={`flex items-start gap-2.5 rounded-lg px-2.5 py-2 text-sm transition-colors hover:bg-background-50 ${
                        i === tickIdx ? "text-foreground-950" : "text-foreground-500"
                      }`}
                    >
                      <span
                        className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-bold text-white ${
                          i === tickIdx ? "bg-primary-500" : "bg-background-300 text-foreground-600"
                        }`}
                      >
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {t}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}